/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * @emails react-core
 */

import NavigationFooter from './NavigationFooter';

export default NavigationFooter;
